export default "__VITE_ASSET__nucSHqRH__"